__webpack_require__.p = "https://alpha.cdn.workspaces-web.com/";